import { render } from "./CareersPage.vue?vue&type=template&id=0aa0c5c4"
import script from "./CareersPage.vue?vue&type=script&lang=js"
export * from "./CareersPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__